module.exports = __webpack_public_path__ + "static/media/icon-date-warning.3199b17a.svg";